import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Tabs, useMediaQuery, useTheme } from '@mui/material';
import { PageLayout } from '@ui/components/PageLayout';
import { useHelpTopic } from '@ui/contexts';
import TabWithBadge from '@ui/components/TabWithBadge';
import { centeredRowStack } from '@ui/style/style';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Iconly } from 'react-iconly';
import { useNavigate, useParams } from 'react-router-dom';
import DetailsTab from './DetailsTab';
import EventsTab from './EventsTab';
import CalendarTab from './CalendarTab';
import ActivityTab from './ActivityTab';
import ContactsTab from './ContactsTab';
import { ArrowLeft2 } from 'iconsax-react';
import { useAppDispatch } from '@application/store/useStore';
import { useSelector } from 'react-redux';
import { hasPermission } from '@application/helpers/permission-helper';
import { useRedirectOnCompanyChange } from '@ui/hooks/useRedirectOnCompanyChange';
const PARTNER_DETAILS_TAB_TOPICS = [
    'partnerDetails',
    'partnerContacts',
    'partnerEvents',
    'partnerCalendar',
    'partnerActivity'
];
const SponsorshipDetails = () => {
    useRedirectOnCompanyChange('/sponsorships');
    const theme = useTheme();
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { partner } = useSelector((state) => state.partner);
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(0);
    useHelpTopic(PARTNER_DETAILS_TAB_TOPICS[activeTab]);
    const loggedInUserPermissions = useSelector((state) => state.auth.currentUser?.permissions || []);
    const canUpdatePartners = hasPermission(loggedInUserPermissions, 'Permissions.Partner.Update');
    const tabLabels = [
        { label: t('sponsorships.details'), value: 0, disabled: false },
        { label: t('sponsorships.contacts'), value: 1, disabled: false },
        { label: t('sponsorships.events'), value: 2, disabled: false },
        { label: t('sponsorships.calendar'), value: 3, disabled: false },
        //{ label: t('sponsorships.interests'), value: 4, disabled: false },
        { label: t('sponsorships.activity'), value: 4, disabled: false }
    ];
    const renderTabContent = () => {
        switch (activeTab) {
            case 0:
                return _jsx(DetailsTab, {});
            case 1:
                return _jsx(ContactsTab, {});
            case 2:
                return _jsx(EventsTab, { partnerId: id });
            case 3:
                return _jsx(CalendarTab, {});
            case 4:
                return _jsx(ActivityTab, {});
            //return <InterestsTab />;
            //case 5:
            default:
                return _jsx(DetailsTab, {});
        }
    };
    return (_jsx(PageLayout, { showBackButton: true, onBackClick: () => navigate(-1), title: partner?.fullName?.trim() ||
            partner?.name?.trim() ||
            `${partner?.firstName ?? ''} ${partner?.lastName ?? ''}`.trim() ||
            t('sponsorships.sponsorshipDetails'), titleVariant: 'h2', showBreadCrumbs: true, backIcon: _jsx(ArrowLeft2, { size: '20' }), rightContent: _jsx(Box, { sx: { ...centeredRowStack }, gap: 1, children: _jsx(Button, { startIcon: _jsx(Iconly, { set: 'curved', name: 'Edit' }), variant: 'contained', size: isSmallScreen ? 'medium' : 'large', color: 'primary', disabled: !canUpdatePartners, onClick: () => {
                    if (id && canUpdatePartners) {
                        navigate(`/sponsorships/new-sponsorship?edit=1&id=${id}`);
                    }
                }, children: t('sponsorships.editSponsorship') }) }), showTabs: true, tabs: _jsx(Tabs, { variant: 'scrollable', scrollButtons: 'auto', value: activeTab, onChange: (_, newValue) => setActiveTab(newValue), children: tabLabels.map(({ label, value, disabled }) => (_jsx(TabWithBadge, { labelText: label, value: value, disabled: disabled }, value))) }), children: _jsxs(Box, { display: 'flex', flexDirection: 'column', sx: {
                height: isSmallScreen ? 'calc(100dvh - 130px)' : 'auto',
                overflow: isSmallScreen ? 'hidden' : 'visible'
            }, children: [_jsx(Box, { sx: {
                        position: isSmallScreen ? 'sticky' : 'static',
                        top: 0,
                        zIndex: 10
                    } }), _jsx(Box, { sx: {
                        flex: 1,
                        overflow: isSmallScreen ? 'auto' : 'visible',
                        pt: theme.spacing(1.5),
                        pr: isSmallScreen ? 1 : 0
                    }, children: renderTabContent() })] }) }));
};
export default SponsorshipDetails;
